import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminSetup() {
    const { setup } = useAuth();
    const nav = useNavigate();
    const [f, setF] = useState({ email: "", password: "", confirm: "", name: "Administrateur" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (f.password.length < 8) return toast.error("Mot de passe : 8 caractères minimum");
        if (f.password !== f.confirm) return toast.error("Les mots de passe ne correspondent pas");
        setLoading(true);
        try {
            await setup(f.email, f.password, f.name);
            toast.success("Compte administrateur créé");
            nav("/admin/dashboard");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-brand-beige flex items-center justify-center p-6">
            <div className="bg-white rounded-3xl p-8 max-w-md w-full shadow-sm" data-testid="admin-setup-page">
                <h1 className="font-heading text-3xl text-brand-ink font-semibold mb-2">
                    Créer le premier administrateur
                </h1>
                <p className="text-sm text-brand-ink/60 mb-6">
                    Cette page n'est disponible qu'une fois. Choisissez un mot de passe robuste.
                </p>
                <form onSubmit={submit} className="space-y-3">
                    <F label="Nom" value={f.name} onChange={(v) => setF({ ...f, name: v })} testid="name" />
                    <F label="Email" type="email" value={f.email} onChange={(v) => setF({ ...f, email: v })} required testid="email" />
                    <F label="Mot de passe (8 caractères minimum)" type="password" value={f.password} onChange={(v) => setF({ ...f, password: v })} required testid="password" />
                    <F label="Confirmer le mot de passe" type="password" value={f.confirm} onChange={(v) => setF({ ...f, confirm: v })} required testid="confirm" />
                    <button disabled={loading} className="primary-btn w-full mt-2" data-testid="submit-btn">
                        {loading ? "Création..." : "Créer mon compte"}
                    </button>
                </form>
                <Link to="/" className="block text-center text-sm text-brand-ink/50 hover:text-[#2A84C8] mt-4">
                    Retour à l'accueil
                </Link>
            </div>
        </div>
    );
}

function F({ label, value, onChange, type = "text", required, testid }) {
    return (
        <label className="block">
            <span className="block text-sm text-brand-ink/70 mb-1">{label}</span>
            <input
                type={type}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                required={required}
                className="w-full min-h-[48px] rounded-xl border border-brand-ink/15 px-4 focus:outline-none focus:ring-2 focus:ring-[#2A84C8]/30 focus:border-[#2A84C8]"
                data-testid={`input-${testid}`}
            />
        </label>
    );
}
